export default class CommentButton {
  constructor() {
    this.button = 'a.video-engagement__comment-button-trigger';
    this.textarea = 'form#new_comment textarea';
  }

  init() {
    this.$button = $(this.button);
    this.$textarea = $(this.textarea);
    this.bindOnClick();
  }

  bindOnClick(){
    this.$button.on('click', this.onClick.bind(this));
  }

  onClick() {
    this.$textarea.focus();
    return false;
  }
}
